import { IGraphqlPagedMapper } from '../../../models/interfaces/I-graphql-paged-mapper';
import { AreaModel } from './area.model';
import { IGraphqlMapper } from '../../../models/interfaces/I-graphql-mapper';

export class AreasMapper implements IGraphqlPagedMapper {
  items: AreaModel[] = [];
  total = 0;

  returnFromJson(json: any): { items: AreaModel[]; total: number } {
    this.items = [];
    const pagedAreas = json['listAreas'];

    pagedAreas['items'].forEach((value: any) => {
      this.items.push({
        id: value['id'],
        region: value['region'],
        city: value['city'],
        location: value['location'],
        companyId: value['company']['id'],
        companyName: value['company']['name'],
      });
    });
    this.total = pagedAreas['total'];
    return { items: this.items, total: this.total };
  }
}

export class DeleteAreaMapper implements IGraphqlMapper {
  result = false;

  returnFromJson(json: any): boolean {
    const value = json['deleteArea'];
    this.result = value;
    return this.result;
  }
}
